window.can = function(permission) {
    permissions = Object.values(permissions);
    if (typeof permissions === "undefined") {
        return false;
    }
    return permissions.includes(permission);
}